// extracted by mini-css-extract-plugin
export var numpadContainer = "_fz-1";
export var phoneButton = "_fz-0";